import ConjBlock from './ConjBlock';

export default ConjBlock;



// WEBPACK FOOTER //
// ./src/components/ConjTable/ConjBlock/index.js